import { ArrowUpRight } from "lucide-react";

export function ProfessionalsSection({ t }) {
    return (
        <section id="professionnels" className="section professionals-section" data-testid="reset365-professionals-section">
            <div className="page-width">
                <div className="section-heading reveal"><p className="eyebrow" data-testid="reset365-professionals-eyebrow">{t.eyebrow}</p><h2 data-testid="reset365-professionals-title">{t.title}</h2><p className="section-heading__body">{t.subtitle}</p></div>
                <div className="professionals-grid">{t.cards.map((card) => <article className="professional-card reveal" key={card.number} data-testid={`reset365-professional-card-${card.number}`}><span className="professional-card__number">{card.number}</span><h3>{card.title}</h3><p>{card.text}</p></article>)}</div>
                <a href="#soumission" className="button button--primary professionals-cta" data-testid="reset365-professionals-cta">{t.cta}<ArrowUpRight size={16} aria-hidden="true" /></a>
            </div>
        </section>
    );
}
